import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { neo4jService } from '../../services/neo4jService';
import ProductCard from '../../components/ProductCard/ProductCard';
import './SearchResults.css';

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const searchProducts = async () => {
      try {
        setLoading(true);
        const results = await neo4jService.searchProducts(query);
        setProducts(results);
        setError(null);
      } catch (err) {
        console.error('Error searching products:', err);
        setError('Failed to search products');
      } finally {
        setLoading(false);
      }
    };

    if (query) {
      searchProducts();
    }
  }, [query]);

  if (loading) {
    return <div className="loading">Searching products...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="search-results">
      <h2>Search Results for "{query}"</h2>
      {products.length === 0 ? (
        <div className="no-results">
          <p>No products found matching "{query}"</p>
        </div>
      ) : (
        <div className="products-grid">
          {products.map((product) => (
            <ProductCard
              key={product.id}
              id={product.id}
              name={product.name}
              price={product.price}
              brand={product.brand}
              condition={product.condition}
              description={product.description}
              image={product.main_image}
              rating={product.rating}
              reviewsCount={product.reviewsCount}
              inStock={product.inStock}
              qty_instock={product.qty_instock}
              originalPrice={product.originalPrice}
              tag={product.tag}
              isNew={product.isNew}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchResults;
